module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topHeader",
    class: {
      hideLeft: _vm.hideLeft
    }
  }, [(_vm.selectMore) ? [_c('mt-header', {
    style: ({
      backgroundColor: _vm.bgcolor
    }),
    attrs: {
      "title": _vm.title,
      "fixed": ""
    }
  }, [(_vm.selectMoreing) ? [_c('span', {
    staticClass: "leftMore",
    attrs: {
      "slot": "left"
    },
    on: {
      "click": _vm.operate
    },
    slot: "left"
  }, [_vm._v(_vm._s(_vm.operateText))]), _vm._v(" "), _c('span', {
    staticClass: "rightMore",
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.cancleSelectMore
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])] : [(_vm.backToClose) ? _c('i', {
    staticClass: "mintui mintui-back",
    attrs: {
      "slot": "left"
    },
    on: {
      "click": _vm.changeFlag
    },
    slot: "left"
  }) : _c('i', {
    staticClass: "mintui mintui-back",
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        return _vm.geturl()
      }
    },
    slot: "left"
  }), _vm._v(" "), _c('span', {
    staticClass: "rightMore",
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.more
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.$t('multi_select')))])]], 2)] : (_vm.simpleTitle) ? [_c('mt-header', {
    style: ({
      backgroundColor: _vm.bgcolor
    }),
    attrs: {
      "title": _vm.title,
      "fixed": ""
    }
  })] : (_vm.noMore) ? [_c('mt-header', {
    style: ({
      backgroundColor: _vm.bgcolor
    }),
    attrs: {
      "title": _vm.title,
      "fixed": ""
    }
  }, [_c('i', {
    staticClass: "mintui mintui-back",
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        return _vm.geturl()
      }
    },
    slot: "left"
  })])] : [_c('mt-header', {
    style: ({
      backgroundColor: _vm.bgcolor
    }),
    attrs: {
      "title": _vm.title,
      "fixed": ""
    }
  }, [_c('i', {
    staticClass: "mintui mintui-back",
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        return _vm.geturl()
      }
    },
    slot: "left"
  }), _vm._v(" "), _c('mt-button', {
    attrs: {
      "slot": "right",
      "icon": "more"
    },
    on: {
      "click": function($event) {
        _vm.sheetVisible = true
      }
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('actionsheet', {
    attrs: {
      "actions": _vm.actions,
      "cancelText": _vm.$t('cancel')
    },
    model: {
      value: (_vm.sheetVisible),
      callback: function($$v) {
        _vm.sheetVisible = $$v
      },
      expression: "sheetVisible"
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-08cd45cd","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/topNav.vue
// module id = 1728
// module chunks = 107